import get from 'transmute/get';
export const getAllAttachmentsSize = attachments => {
  return attachments.reduce((accum, attachment) => {
    const attachmentSize = get('size', attachment); // attachment can come in as a POJO or ImmutableMap
    accum += attachmentSize;
    return accum;
  }, 0);
};